import { format } from 'date-fns'

export const toThaiYear = (year) => {
    return parseInt(year) + 543
}

export const toThaiDateString = (date) => {
    if (!date) return ''
    const d = new Date(date)
    return format(d, 'dd/MM/') + (d.getFullYear() + 543)
}
